import type {
  IBaselineResetDaysFlowResponse,
  IBaselineSimulatorResponse,
  IDayEstimation,
  IResetDaysList,
} from '@/types/eos/BaselineResetDaysTracker'
import axios from 'axios'

export const getBaseLineResetDaysBetweenDates = async (
  startIsoDate: string,
  endIsoDate: string,
  site: string
): Promise<IResetDaysList> => {
  const res = await axios.get(`${import.meta.env.VITE_APP_SITES_ENDPOINT}/${site}/baseline-reset-days`, {
    params: {
      start_date: startIsoDate,
      end_date: endIsoDate,
    },
  })
  return res.data
}

export const getBaselineResetDayEstimation = async (isoDate: string, site: string): Promise<IDayEstimation> => {
  const res = await axios.get(`${import.meta.env.VITE_APP_SITES_ENDPOINT}/${site}/baseline-reset-days/day-estimation`, {
    params: { day: isoDate },
  })
  return res.data
}

/**
 * Retrieves baseline simulation data for a specific site and day.
 *
 * @param siteID - The unique identifier of the site
 * @param day - A date string in YYYY-MM-DD format
 * @returns A promise that resolves to the baseline simulator response
 */
export const getBaselineSimulator = async (siteID: string, day: string): Promise<IBaselineSimulatorResponse> => {
  const res = await axios.get(`${import.meta.env.VITE_APP_SITES_ENDPOINT}/${siteID}/baseline-reset-days/simulation`, {
    params: { day },
  })
  return res.data
}

/**
 * Retrieves the per-hour flow breakdown for each reset day in the simulation's lookback window.
 * Re-fetches the same 45-day lookback as `getBaselineSimulator`, so it's not free - only call it
 * when the reset days table section is expanded.
 *
 * @param siteID - The unique identifier of the site
 * @param day - A date string in YYYY-MM-DD format
 * @returns A promise that resolves to the baseline reset days flow response
 */
export const getBaselineResetDaysFlow = async (
  siteID: string,
  day: string
): Promise<IBaselineResetDaysFlowResponse> => {
  const res = await axios.get(
    `${import.meta.env.VITE_APP_SITES_ENDPOINT}/${siteID}/baseline-reset-days/simulation/flow`,
    { params: { day } }
  )
  return res.data
}
